import BaseTracker from './base-tracker';

export default class RewindTracker extends BaseTracker {
  start() {
    this._player.addEventListener('seeking', this._onSeeking);
  }

  _onSeeking = () => {
    this.track();
  };

  stop() {
    this._player.removeEventListener('seeking', this._onSeeking);
  }
}
